import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2b598357"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  id: "professional-service-support"
};
const _hoisted_2 = {
  class: "view-content"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "专业服务支持", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "以客户成功为核心目标，提供一对一的陪伴式服务", -1));
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = {
  class: "intro"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _hoisted_4, _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.OPTIONS, (item, i) => {
    return _openBlock(), _createElementBlock("li", {
      key: i
    }, [_createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(item.intro), 1)]);
  }), 128))])])]);
}